import { StorageBaseService, StorageType } from './storage-base.service';

export class SessionStorage extends StorageBaseService {
  static override type = StorageType.Session;
}
